import styles from "./MatrixOperations.module.css";
import OperationsBox from "../../components/operationsBox/OperationsBox";

const MatrixOperations = () => {
    return (
        <div className={styles.page_wrapper}>
            <div className={styles.header_wrapper}>
                <h1 className={styles.title}>
                    Matrix <span id={styles.keyword}>Operations</span>
                </h1>
            </div>
            <div className={styles.body_wrapper}>
                <OperationsBox/>
            </div>
        </div>
    );
};

export default MatrixOperations;